/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";

export default function PublicFaq() {
  const { ApiBaseUrl } = useContext(MyContext);
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${ApiBaseUrl}/customer/faq_list`)
      .then((r) => setFaqs(r.data.faq_list || []))
      .catch(() => setFaqs([]))
      .finally(() => setLoading(false));
  }, [ApiBaseUrl]);

  const needle = q.trim().toLowerCase();
  const shown = needle
    ? faqs.filter(
        (f) =>
          String(f.title || "").toLowerCase().includes(needle) ||
          String(f.description || "").toLowerCase().includes(needle)
      )
    : faqs;

  return (
    <div className="width-container py-[40px]">
      <div className="max-w-[720px] mx-auto text-center">
        <p className="text-[13px] uppercase tracking-wide font-[700] text-rm-primary">Help Centre</p>
        <h1 className="text-[34px] leading-tight font-[800] text-rm-ink mt-[6px]">
          Frequently asked questions
        </h1>
        <p className="text-rm-muted mt-[10px]">
          Everything about bookings, payments, refunds and how our providers are verified.
        </p>
        <input
          className="w-full border border-rm-line rounded-[12px] px-[16px] py-[12px] mt-[20px]"
          placeholder="Search questions"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      <div className="max-w-[820px] mx-auto mt-[28px]">
        {loading && <p className="text-center text-rm-muted py-[40px]">Loading…</p>}

        {!loading && shown.map((f) => {
          const isOpen = open === f.id;
          return (
            <div key={f.id} className="border border-rm-line rounded-[16px] bg-white mb-[12px] overflow-hidden">
              <button
                type="button"
                className="w-full text-left px-[20px] py-[16px] flex items-center justify-between gap-4"
                onClick={() => setOpen(isOpen ? null : f.id)}
                aria-expanded={isOpen}
              >
                <span className="font-[700] text-rm-ink text-[16px]">{f.title}</span>
                <span className={`text-rm-primary text-[22px] leading-none transition-transform ${isOpen ? "rotate-45" : ""}`}>+</span>
              </button>
              {isOpen && (
                <p className="px-[20px] pb-[18px] -mt-[4px] text-[15px] text-rm-muted leading-relaxed">
                  {f.description}
                </p>
              )}
            </div>
          );
        })}

        {!loading && !shown.length && (
          <p className="text-center text-rm-muted py-[40px]">
            {needle ? "No questions match that search." : "No questions have been published yet."}
          </p>
        )}
      </div>

      <div className="max-w-[820px] mx-auto mt-[30px] border border-rm-line rounded-[18px] p-[24px] bg-rm-softbg text-center">
        <h3 className="text-[20px] font-[800] text-rm-ink">Still stuck?</h3>
        <p className="text-rm-muted mt-[6px]">Our support team is available 24/7.</p>
        <div className="flex flex-wrap gap-[10px] justify-center mt-[14px]">
          <a href="tel:+919429694496" className="inline-block bg-rm-gradient text-white font-[700] text-[14px] px-[16px] py-[10px] rounded-[12px]">Call +91 94296 94496</a>
          <a href="mailto:care@rapidmedik.in" className="inline-block border border-rm-line text-rm-ink font-[700] text-[14px] px-[16px] py-[10px] rounded-[12px] bg-white hover:border-rm-primary hover:text-rm-primary transition">care@rapidmedik.in</a>
          <Link to="/corporate" className="inline-block border border-rm-line text-rm-ink font-[700] text-[14px] px-[16px] py-[10px] rounded-[12px] bg-white hover:border-rm-primary hover:text-rm-primary transition">Corporate enquiries</Link>
        </div>
      </div>
    </div>
  );
}
